<script>
  import { createEventDispatcher } from 'svelte';
  export let settings;
  let devices = [];
  let loading = false;
  let error = "";
  let path = "";
  const dispatch = createEventDispatcher();

  if (window.platform == "Android") {
        path = androidAdapter.getPath();
        if (settings.location == "gnss") {
            devices = JSON.parse(androidAdapter.getDevices());
            devices.map(function (device) {
                device.value = device.value.replace(/:/g, "")
            });
        }
    }

  async function sourceChanged(event) {
    settings.location = event.target.value;
    if (event.target.value == "gnss") {
        devices = JSON.parse(androidAdapter.getDevices());
        devices.map(function (device) {
            device.value = device.value.replace(/:/g, "")
        });
    }
  }

  async function saveHandler() {
      loading = true;
      if (settings.bearing > 360)
        settings.bearing = 360;
      if (settings.bearing < -180)
        settings.bearing = -180;
      if (settings.distance < 0)
        settings.distance = 0;
      if (window.platform == "Android" && window.apiVersion >= 4) {
        androidAdapter.setWifiOnly(settings.wifiOnly ? "1" : "0");
      }
      dispatch('message', {
          type: "settings",
          data: settings
      });
      loading = false;
      close();
  }

  function close() {
		dispatch('message', {
      type: "modal",
      modal: null
		});
  }
</script>

<div class="modal modal-sm active">
    <div class="modal-overlay"></div>
    <div class="modal-container">
        <div class="modal-header">
            <button class="btn btn-clear float-right" on:click={close} aria-label="Close"></button>
            <div class="modal-title h5">Settings</div>
        </div>
        <div class="modal-body">
            <form class="content" on:submit|preventDefault={saveHandler}>
                <label class="form-label" for="location">Location Source</label>
                <select class="form-select" on:change={sourceChanged} value={settings.location}>
                    <option value="default">Default</option>
                    {#if window.platform == "Android" || window.platform == "iOS"}
                        <option value="gnss">Trimble GNSS</option>
                    {/if}
                    {#if window.platform == "iOS"}
                        <option value="eos">Leica/EOS GNSS</option>
                    {/if}
                     <option value="ws">Trimble Websocket</option>
                </select>
                {#if settings.location == "gnss" && window.platform != "iOS"}
                    <label class="form-label" for="device">GNSS Device</label>
                    <select class="form-select" bind:value={settings.device}>
                        <option value="">Not set</option>
                        {#each devices as device}
                            <option value={device.value}>{device.name}</option>
                        {/each}
                    </select>
                {:else if settings.location == "gnss" && window.platform == "iOS"}
                    <label class="form-label" for="serial">GNSS Serial Number</label>
                    <input class="form-input" bind:value={settings.serial} type="text" id="serial">
                {/if}
                <div class="tile tile-centered mt-2">
                    <div class="tile-content">
                        <div class="tile-title">Enable accuracy threshold</div>
                    </div>
                    <div class="tile-action">
                        <div class="form-group">
                            <label id="offset" class="form-switch">
                                <input type="checkbox" bind:checked={settings.hasMaxAccuracy}> 
                                <i class="form-icon"></i>
                            </label>
                        </div>
                    </div>
                </div>
                {#if settings.hasMaxAccuracy}
                    <label class="form-label" for="maximum-accuracy">Maximum Accuracy</label>
                    <input class="form-input" bind:value={settings.maxAccuracy} type="number" min="0" max="100" id="maximum-accuracy">
                {/if}
                <div class="tile tile-centered mt-2">
                    <div class="tile-content">
                        <div class="tile-title">Enable location tracking</div>
                    </div>
                    <div class="tile-action">
                        <div class="form-group">
                            <label id="offset" class="form-switch">
                                <input type="checkbox" bind:checked={settings.tracking}> 
                                <i class="form-icon"></i>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="tile tile-centered mt-2">
                    <div class="tile-content">
                        <div class="tile-title">Enable location offset</div>
                    </div>
                    <div class="tile-action">
                        <div class="form-group">
                            <label id="offset" class="form-switch">
                                <input type="checkbox" bind:checked={settings.offset}> 
                                <i class="form-icon"></i>
                            </label>
                        </div>
                    </div>
                </div>
                {#if settings.offset}
                    <label class="form-label" for="offset-bearing">Offset Bearing</label>
                    <input class="form-input" bind:value={settings.bearing} type="number" min="-180" max="360" id="offset-bearing">
                    <label class="form-label" for="offset-distance">Offset Distance</label>
                    <input class="form-input" bind:value={settings.distance} type="text" min="0" id="offset-distance">
                {/if}
                <label class="form-label" for="units">Units</label>
                <select class="form-select" bind:value={settings.units}>
                    <option value="feet">Feet</option>
                    <option value="miles">Miles</option>
                    <option value="meters">Meters</option>
                    <option value="kilometers">Kilometers</option>
                </select>
                <label class="form-label" for="units">Location Line Interval</label>
                <select class="form-select" bind:value={settings.interval}>
                    <option value="1">1 second</option>
                    <option value="5">5 seconds</option>
                    <option value="10">10 seconds</option>
                    <option value="20">20 seconds</option>
                    <option value="30">30 seconds</option>
                    <option value="60">60 seconds</option>
                </select>
                <div class="tile tile-centered mt-2">
                    <div class="tile-content">
                        <div class="tile-title">Enable map rotation</div>
                    </div>
                    <div class="tile-action">
                        <div class="form-group">
                            <label id="newTab" class="form-switch">
                                <input type="checkbox" bind:checked={settings.rotation}> 
                                <i class="form-icon"></i>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="tile tile-centered">
                    <div class="tile-content">
                        <div class="tile-title">Open links in new tab</div>
                    </div>
                    <div class="tile-action">
                        <div class="form-group">
                            <label id="newTab" class="form-switch">
                                <input type="checkbox" bind:checked={settings.newTab}> 
                                <i class="form-icon"></i>
                            </label>
                        </div>
                    </div>
                </div>
                {#if window.platform == "Android" && window.apiVersion >= 4}
                    <div class="tile tile-centered">
                        <div class="tile-content">
                            <div class="tile-title">Only upload media on Wifi</div>
                        </div>
                        <div class="tile-action">
                            <div class="form-group">
                                <label id="wifiOnly" class="form-switch">
                                    <input type="checkbox" bind:checked={settings.wifiOnly}> 
                                    <i class="form-icon"></i>
                                </label>
                            </div>
                        </div>
                    </div>
                {/if}

                    <label class="form-label" for="path">Local Path</label>
                    <input class="form-input" bind:value={path} type="text" id="path" readonly>

                <input type="submit" style="position: absolute; left: -9999px"/>
            </form>
        </div>
        <div class="modal-footer">
            <div class="tile tile-centered text-left">
                <div class="tile-content">
                    <div class="tile-title error">{error}</div>
                </div>
                <div class="tile-action">
                    {#if loading}
                        <button class="btn btn-primary loading">Save</button>
                    {:else}
                        <button class="btn btn-primary" on:click={saveHandler}>Save</button>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .error {
        color: red;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .modal-container .modal-header {
        padding-bottom: 0;
    }
    .modal-container .modal-body {
        padding-top: 0;
    }
    .modal-container .modal-footer {
        padding-top: 0;
    }
    .form-group {
        margin: 0.2rem 0;
    }
    .form-switch {
        margin: 0;
    }
</style>